import * as ng from '@angular/core';

@ng.Directive()
export class BaseError implements ng.AfterViewInit {
  constructor(private elementRef: ng.ElementRef) {
  }
  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = 'white';
  }
}
